module.exports = "/packs/images/svg/ireland/facilities/library~6af1ebe2f033a237b1a67261b35a6b1f.svg";